export class GetEnvironmentVersionsResponse {
    versions?: string[];
}